function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: "48",
  viewBox: "-300 -1200 1400 1400",
  width: "48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M280-491h400q12.75 0 21.375-9.175 8.625-9.176 8.625-21 0-12.825-8.625-21.325T680-551H280q-12.75 0-21.375 8.675-8.625 8.676-8.625 21.5Q250-509 258.625-500T280-491zm0 160h240q12.75 0 21.375-9.175 8.625-9.176 8.625-21 0-12.825-8.625-21.325T520-391H280q-12.75 0-21.375 8.675-8.625 8.676-8.625 21.5Q250-349 258.625-340T280-331zM151-140q-37.175 0-64.088-27.094Q60-194.188 60-231v-509q0-37.225 26.912-64.613Q113.825-832 151-832h225q18.016 0 34.624 8.043 16.608 8.044 29.464 20.045L481-764h330q37.225 0 64.613 27.387Q903-709.225 903-672v441q0 36.812-27.387 63.906Q848.225-140 811-140H151z"
})));